import { jsx } from 'react/jsx-runtime';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    outlineButton: {
        border: `${theme.palette.secondary.main} 1px solid`,
        color: theme.palette.secondary.main,
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main + "10"
        }
    }
}));
const OutlineButton = ({ children, className, ...props }) => {
    const { classes, cx } = useStyles();
    return (jsx(Button, { className: cx(classes.outlineButton, className), ...props, children: children }));
};

export { OutlineButton };
